import { MouseEvent } from 'react';
import { useRouter } from 'next/navigation';
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';
import classNames from 'classnames';
import { AppNextLink } from '@/features/app-next-link';
import { IconArrowSquareDown } from '@/components/svg-symbols/icons';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import { useCategoryModal } from '../../category-modal/context/category-modal-context';
import { SubLink } from '../../types';
interface Props {
  title: string;
  links: SubLink[];
  parentLink: string;
}
function SubMenuExpandablePanel({
  title,
  links,
  parentLink
}: Props) {
  const {
    close: closeCategory
  } = useCategoryModal();
  const router = useRouter();
  const closeSubMenuHandler = (e: MouseEvent, href: string, closeDisclosurePanel: () => void) => {
    e.preventDefault();
    closeDisclosurePanel();
    closeCategory();
    router.replace(href);
  };
  return <Disclosure defaultOpen={PUBLIC_IS_BOT} data-sentry-element="Disclosure" data-sentry-component="SubMenuExpandablePanel" data-sentry-source-file="sub-menu-expandable-panel.tsx">
            {({
      open,
      close
    }) => <>
                    <DisclosureButton className='flex w-full items-center justify-between px-2 py-2.5 text-text-black'>
                        <span className='text-sm font-medium leading-6'>{title}</span>

                        <IconArrowSquareDown className={classNames('h-6 w-6 transition-all duration-200', {
          'rotate-180': open
        })} />
                    </DisclosureButton>
                    <Transition as='div' className='overflow-hidden transition-all duration-200' enterFrom='transform max-h-0' enterTo='transform' leaveFrom='transform' leaveTo='transform max-h-0'>
                        <DisclosurePanel className='flex flex-col gap-0 text-xs font-medium text-text-darkGray [&>a]:px-2 [&>a]:py-2.5'>
                            <AppNextLink className='text-text-black' href={parentLink} prefetch={false} onClick={e => {
            closeSubMenuHandler(e, parentLink, close);
          }}>
                                همه محصولات {title}
                            </AppNextLink>
                            {links.map((link, index) => {
            const linkHref = link.useHrefWithoutParent ? link.href : `${parentLink}${link.href}`;
            return <AppNextLink href={linkHref} key={`${link.title}${index}`} prefetch={false} className='px-2 py-2.5' onClick={e => {
              closeSubMenuHandler(e, linkHref, close);
            }}>
                                        {link.title}
                                    </AppNextLink>;
          })}
                        </DisclosurePanel>
                    </Transition>
                </>}
        </Disclosure>;
}
export default SubMenuExpandablePanel;